export interface IAddAccessInputValue {
  login: string;
  contract: { value: number; label: string } | null;
  clientId: string;
  clientSecret: string;
  email: string;
}

export interface IEditAccessInputValue {
  login: string;
  contract: { value: number; label: string } | null;
  clientId: string;
  clientSecret: string;
  id: number;
}

export const initialAddInputState: IAddAccessInputValue = {
  contract: null,
  login: "",
  clientId: "",
  clientSecret: "",
  email: "",
};

export const initialEditInputState: IEditAccessInputValue = {
  contract: null,
  login: "",
  clientId: "",
  clientSecret: "",
  id: 0,
};
